import { environment } from 'src/environments/environment';

export class APIService {
  protected _baseUrl = environment.baseUrl;

  constructor() {}
}
